import Enum from "../../../../../../enums/Enum";

const CurrentPreviousEnum = new Enum({
    CURRENT: {name: "Current"},
    PREVIOUS: {name: "Previous"}
});

export default CurrentPreviousEnum;